import { CatalogManagementState, initialCatalogManagementState } from "./catalog-management/catalog-management.state";
import { ContractManagementState, initialContractManagementState } from "./contract-management/contract-management.state";
import { ContractReportsState, initialContractReportsState } from "./contract-reports/contract-reports.state";
import { CatalogDatasetsState, initialCatalogDatasetsState } from "./catalog-datasets/catalog-datasets.state";
import { AppError } from "../../../app-store-error.types";

// **************************************************************************
// CONTRACT ADMIN STATE
// Note: Contracts and Catalogs LIST DATA is managed by entities stores
// This store handles admin-specific CRUD operations and features
// **************************************************************************
export interface ContractAdminState {
    catalogManagement: CatalogManagementState;
    contractManagement: ContractManagementState;
    contractReports: ContractReportsState;
    catalogDatasets: CatalogDatasetsState;
    error: AppError | null;
}

export const initialContractAdminState: ContractAdminState = {
    catalogManagement: initialCatalogManagementState,
    contractManagement: initialContractManagementState,
    contractReports: initialContractReportsState,
    catalogDatasets: initialCatalogDatasetsState,
    error: null,
};
